class FeeAccordion {
    constructor() {
        this.tableButton = document.getElementsByClassName('fee-accordion');

        this.events();
    }

    events() {
        for (let i = 0; i < this.tableButton.length; i++) {
            this.tableButton[i].addEventListener('click', this.toggleAccordion.bind(this));
        }
    }

    toggleAccordion(e) {
        const parent = e.target.closest('.table-container');
        const table = parent.querySelector('.table-wrapper');
        const icon = parent.querySelector('.plus-wrapper');

        // check if another card that is already active.
        const activeCard = document.querySelector('.table-container.active');

        if (activeCard && activeCard !== parent) {
            const activeTable = activeCard.querySelector('.table-wrapper');
            const activeIcon = activeCard.querySelector('.plus-wrapper');

            // remove active class lists
            activeCard.classList.remove('active');
            activeIcon.classList.remove('active');

            // update styling
            activeTable.style.maxHeight = null;
            activeTable.style.paddingTop = null;
        }

        parent.classList.toggle('active');
        icon.classList.toggle('active');

        if (table.style.maxHeight) {
            table.style.maxHeight = null;
            table.style.paddingTop = null;
        } else {
            table.style.paddingTop = '30px';
            table.style.maxHeight = `${ table.scrollHeight + 40 }px`;
        }
    }
}

export default FeeAccordion;